import { useHistory, useLocation } from 'react-router-dom';
import { useMemo } from 'react';

const useSearchParams: <T extends Record<any, any>>() => [
  T,
  (arg0: T) => void,
] = () => {
  const { search } = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const setParams = (value: Record<any, any>) => {
    Object.keys(value).forEach(key => {
      if (
        value[key] === undefined ||
        value[key] === null ||
        (Array.isArray(value[key]) && value[key].length === 0)
      ) {
        searchParams.delete(key);
      } else {
        searchParams.set(key, encodeURIComponent(JSON.stringify(value[key])));
      }
    });

    history.replace({ search: searchParams.toString() });
  };

  const params = useMemo(() => {
    const obj: Record<any, any> = {};
    searchParams.forEach((value, key) => {
      obj[key] = JSON.parse(decodeURIComponent(value));
    });
    return obj;
  }, [searchParams]);

  return [params, setParams];
};

export default useSearchParams;
